import { useEffect, useState } from "react";
import { fmtHourly } from "../lib/money.js";
import { Field, Select } from "./ui.jsx";
import { api } from "../lib/api.js";

// Priced plan chooser for the create forms. kind = "compute" (services) | "db"
// (databases). Fetches /api/plans, shows a dropdown with the price in each label,
// and a live spec/price line under it. value/onChange carry the plan id, which the
// create routes already accept as plan_id.
const specOf = (p) => (p.vcpu ? `${p.vcpu} · ${p.ram} · ${p.disk}` : `${p.ram} RAM · ${p.storage} storage`);

export default function PlanPicker({ kind = "compute", value, onChange, label = "Plan" }) {
  const [plans, setPlans] = useState(null);
  useEffect(() => {
    let off = false;
    api.plans()
      // There is no free tier: a plan without a positive monthly price is never offered,
      // whatever the catalogue happens to contain.
      .then((d) => { if (!off) setPlans(((kind === "db" ? d?.db : d?.compute) || []).filter((p) => Number(p?.priceMo) > 0)); })
      .catch(() => { if (!off) setPlans([]); });
    return () => { off = true; };
  }, [kind]);

  if (plans === null) return <p className="text-xs" style={{ color: "var(--text-muted)" }}>Loading plans…</p>;
  if (plans.length === 0) return <p className="text-xs" style={{ color: "var(--err-text)" }}>Plans are unavailable. Please try again before creating a resource.</p>;
  const sel = plans.find((p) => p.id === value) || null;

  return (
    <Field label={label}>
      <Select required value={value || ""} onChange={(e) => onChange(e.target.value)}>
        <option value="" disabled>Select a paid plan…</option>
        {plans.map((p) => (
          <option key={p.id} value={p.id}>{p.name} — {fmtHourly(p.priceMo)} (about ${p.priceMo}/mo) · {specOf(p)}</option>
        ))}
      </Select>
      {sel ? (
        <p className="mt-1.5 text-xs" style={{ color: "var(--text-muted)" }}>
          <span style={{ color: "var(--text)", fontWeight: 600 }}>{fmtHourly(sel.priceMo)}</span> · about ${sel.priceMo}/mo, billed daily for the hours it runs · {specOf(sel)}
          {sel.renderMo ? ` — ${Math.round((1 - sel.priceMo / sel.renderMo) * 100)}% under Render` : ""}
        </p>
      ) : (
        <p className="mt-1.5 text-xs" style={{ color: "var(--text-muted)" }}>
          Choose a paid plan to set resource limits and monthly price.
        </p>
      )}
    </Field>
  );
}
